import FadeIn from '../components/FadeIn';
import { SERVICES, WHY_ITEMS, WA_URL } from '../data/constants';

const HERO_STATS = [
  { label: 'Servicios especializados', num: '13+', sub: 'Soluciones técnicas integrales' },
  { label: 'Productos en catálogo',    num: '10+', sub: 'Equipos, repuestos y accesorios' },
  { label: 'Atención de emergencias',  num: '24/7', sub: 'Respuesta inmediata garantizada' },
];

export default function Home({ goTo }) {
  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        <div className="hero-left">
          <FadeIn>
            <div className="hero-eyebrow">Estaciones de servicio · Colombia</div>
            <h1 className="hero-title">
              Mantenimiento<br />
              <em>técnico</em> para<br />
              tu estación
            </h1>
            <p className="hero-body">
              Servicios especializados en instalación y mantenimiento de equipos
              electrónicos para estaciones de servicio y la industria del petróleo.
              NIT 901.248.424-3.
            </p>
            <div className="hero-actions">
              <button className="btn btn-fuel" onClick={() => goTo('contacto')}>
                Solicitar servicio
              </button>
              <button className="btn btn-outline" onClick={() => goTo('servicios')}>
                Ver portafolio
              </button>
            </div>
          </FadeIn>
        </div>

        <div className="hero-right">
          {HERO_STATS.map((s, i) => (
            <FadeIn key={s.label} delay={80 + i * 60}>
              <div className="stat-block">
                <div className="stat-label">{s.label}</div>
                <div className="stat-num">
                  {s.num} <span>{s.sub}</span>
                </div>
                <div className="stat-accent" />
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <div className="divider" />

      {/* ── SERVICIOS (preview) ── */}
      <section className="sec sec-warm">
        <FadeIn>
          <div className="sec-tag">Lo que hacemos</div>
          <h2 className="sec-title">Nuestros servicios</h2>
          <p className="sec-sub">
            Cobertura técnica integral para mantener tu estación operando con seguridad y eficiencia.
          </p>
        </FadeIn>

        <div className="svc-grid">
          {SERVICES.slice(0, 6).map((s, i) => (
            <FadeIn key={s.name} delay={i * 50}>
              <div className="svc-card">
                <div className="svc-icon">{s.icon}</div>
                <div className="svc-num">{String(i + 1).padStart(2, '0')}</div>
                <div className="svc-name">{s.name}</div>
                <p className="svc-desc">{s.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={340}>
          <div style={{ marginTop: 28, textAlign: 'center' }}>
            <button className="btn btn-outline btn-sm" onClick={() => goTo('servicios')}>
              Ver todos los servicios ({SERVICES.length}) →
            </button>
          </div>
        </FadeIn>
      </section>

      <div className="divider" />

      {/* ── POR QUÉ M&RG ── */}
      <section className="sec sec-white">
        <FadeIn>
          <div className="sec-tag">¿Por qué M&amp;RG?</div>
          <h2 className="sec-title">
            Confianza construida<br />en cada intervención
          </h2>
        </FadeIn>

        <div className="why-grid">
          <div className="why-left">
            {WHY_ITEMS.map((w, i) => (
              <FadeIn key={w.title} delay={i * 75}>
                <div className="why-item">
                  <div className="why-n">0{i + 1}</div>
                  <div className="why-body">
                    <h4>{w.title}</h4>
                    <p>{w.desc}</p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>

          <div className="why-right">
            <FadeIn delay={150}>
              <div className="why-visual">
                <div>
                  <div className="why-big">NIT</div>
                  <div style={{ fontFamily: "'Merriweather',serif", fontSize: 26, fontWeight: 900, color: '#FFFFFF', lineHeight: 1, marginTop: 4 }}>
                    901.248.424-3
                  </div>
                  <div className="why-vlabel">Empresa legalmente constituida · Colombia</div>
                </div>
                <div className="why-vdiv" />
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,.55)', lineHeight: 1.8, fontWeight: 300 }}>
                  Empresa especializada en la instalación y mantenimiento de equipos
                  electrónicos para estaciones de servicio y la industria del petróleo,
                  con los más altos estándares de calidad.
                </p>
                <button
                  className="btn btn-fuel btn-sm"
                  style={{ marginTop: 24, background: '#D4600A' }}
                  onClick={() => goTo('contacto')}
                >
                  Contactar ahora
                </button>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── CTA STRIP ── */}
      <div className="fuel-strip">
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.2em', textTransform: 'uppercase', color: '#D4600A', marginBottom: 8 }}>
            Atención inmediata
          </div>
          <h3 style={{ fontFamily: "'Merriweather',serif", fontSize: 28, fontWeight: 900, color: '#FFFFFF', lineHeight: 1.2 }}>
            ¿Necesitas asistencia ahora?
          </h3>
        </div>
        <a
          href={WA_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn"
          style={{ background: '#25D366', color: '#000', padding: '13px 28px', borderRadius: '4px' }}
        >
          💬 WhatsApp · 312 834 87 79
        </a>
      </div>
    </>
  );
}
